export const zofiaKurowska = {
    'meta': {
        'title': 'Psycholog, pedagog Zofia Kurowska',
        'description': 'Jestem dyplomowanym pedagogiem, psychologiem i terapeutą wczesnego wspomagania rozwoju dziecka.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-pedagog-zofia-kurowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/zofia-kurowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, pedagog Zofia Kurowska'
        }
    }
}